import { OptionCard, Select} from "../../index";
import React, { useEffect, useState, useCallback } from 'react';
import "./SelectComune.scss";
import { getComuni  } from "../../../api";
import { toast } from "react-toastify";
import CustomSelect from "../../Common/CustomSelect/CustomSelect";

export const SelectComune = ({ handleOnCloseSocialIcon, selectedComune, onSelectComune, setLayers}) => {
  const [selectedId, setSelectedId] = useState();
  const [comuni, setComuni] = useState([]);

  const handleSelectChange = (what, option) => {
    setSelectedId(option.value);
    setLayers([]);
    onSelectComune(comuni?.find(comune => comune.id === option.value));
  };


  

  //******************************************************************* */
  //    FETCHING THE LIST OF COMUNI
  useEffect(() => {
    const fetchComuni = async () => {
      try {
        const data = await getComuni([
          {key: "pageSize", value: 1000},
          {key: "page", value: 1},
          {key: "sort", value: "nome,asc"}]);
         if(data.length === 0) {
           console.error(`The list of "comuni" is empty`);
         } else {
            setComuni(data.results.filter(comune => comune.nome!=="ITALIA"));
         }
      } catch (error) {
          console.error(`Error fetching municipilaty names: ${error.message}`);
      }
    }
    fetchComuni();
  }, []);

  

  return (
    <OptionCard
      title="Selezione comune, frazione o parco"
      className="select-municipality-card-container"
      onCrossClick={handleOnCloseSocialIcon}
    >
      {/* <Select
        className="municipality-select-input"
        options={[
          { value: "Municipality 1" },
          { value: "Municipality 2" },
          { value: "Municipality 3" },
        ]}
        label="Select Municipality"
      /> */}
      <CustomSelect
        name="location"
        initValue={selectedComune}
        className="municipality-select-input"
        options={comuni?.map((option) => ({
          value: option.id,
          label: option.nome
        }))}
        label="Editare per ridurre la lista"
        onChange={handleSelectChange}
        placeholder="Seleziona un parco o un comune"
        disabled={false}
      />
      
    </OptionCard>
  );
};
